export default function checkIsNewThread(id) {
  return id?.toLocaleUpperCase() === 'NEW';
}
